import * as Types from './2026-07-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;

export const FetchCollectionsDocument = gql`
    query FetchCollections($endCursor: String) {
  collections(
    first: 250
    query: "NOT status:Archived AND hasProduct:True"
    after: $endCursor
  ) {
    edges {
      node {
        id
        title
        handle
        templateSuffix
        description
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    `;

/**
 * __useFetchCollectionsQuery__
 *
 * To run a query within a React component, call `useFetchCollectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCollectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCollectionsQuery({
 *   variables: {
 *      endCursor: // value for 'endCursor'
 *   },
 * });
 */
export function useFetchCollectionsQuery(baseOptions?: Apollo.QueryHookOptions<Types.FetchCollectionsQuery, Types.FetchCollectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.FetchCollectionsQuery, Types.FetchCollectionsQueryVariables>(FetchCollectionsDocument, options);
      }
export function useFetchCollectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.FetchCollectionsQuery, Types.FetchCollectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.FetchCollectionsQuery, Types.FetchCollectionsQueryVariables>(FetchCollectionsDocument, options);
        }
// @ts-ignore
export function useFetchCollectionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.FetchCollectionsQuery, Types.FetchCollectionsQueryVariables>): Apollo.UseSuspenseQueryResult<Types.FetchCollectionsQuery, Types.FetchCollectionsQueryVariables>;
export function useFetchCollectionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.FetchCollectionsQuery, Types.FetchCollectionsQueryVariables>): Apollo.UseSuspenseQueryResult<Types.FetchCollectionsQuery | undefined, Types.FetchCollectionsQueryVariables>;
export function useFetchCollectionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.FetchCollectionsQuery, Types.FetchCollectionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.FetchCollectionsQuery, Types.FetchCollectionsQueryVariables>(FetchCollectionsDocument, options);
        }
export type FetchCollectionsQueryHookResult = ReturnType<typeof useFetchCollectionsQuery>;
export type FetchCollectionsLazyQueryHookResult = ReturnType<typeof useFetchCollectionsLazyQuery>;
export type FetchCollectionsSuspenseQueryHookResult = ReturnType<typeof useFetchCollectionsSuspenseQuery>;
export type FetchCollectionsQueryResult = Apollo.QueryResult<Types.FetchCollectionsQuery, Types.FetchCollectionsQueryVariables>;
export const FetchCollectionsAllDocument = gql`
    query FetchCollectionsAll($endCursor: String) {
  collections(first: 250, query: "NOT status:Archived", after: $endCursor) {
    edges {
      node {
        id
        title
        handle
        templateSuffix
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    `;

/**
 * __useFetchCollectionsAllQuery__
 *
 * To run a query within a React component, call `useFetchCollectionsAllQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCollectionsAllQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCollectionsAllQuery({
 *   variables: {
 *      endCursor: // value for 'endCursor'
 *   },
 * });
 */
export function useFetchCollectionsAllQuery(baseOptions?: Apollo.QueryHookOptions<Types.FetchCollectionsAllQuery, Types.FetchCollectionsAllQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.FetchCollectionsAllQuery, Types.FetchCollectionsAllQueryVariables>(FetchCollectionsAllDocument, options);
      }
export function useFetchCollectionsAllLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.FetchCollectionsAllQuery, Types.FetchCollectionsAllQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.FetchCollectionsAllQuery, Types.FetchCollectionsAllQueryVariables>(FetchCollectionsAllDocument, options);
        }
// @ts-ignore
export function useFetchCollectionsAllSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.FetchCollectionsAllQuery, Types.FetchCollectionsAllQueryVariables>): Apollo.UseSuspenseQueryResult<Types.FetchCollectionsAllQuery, Types.FetchCollectionsAllQueryVariables>;
export function useFetchCollectionsAllSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.FetchCollectionsAllQuery, Types.FetchCollectionsAllQueryVariables>): Apollo.UseSuspenseQueryResult<Types.FetchCollectionsAllQuery | undefined, Types.FetchCollectionsAllQueryVariables>;
export function useFetchCollectionsAllSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.FetchCollectionsAllQuery, Types.FetchCollectionsAllQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.FetchCollectionsAllQuery, Types.FetchCollectionsAllQueryVariables>(FetchCollectionsAllDocument, options);
        }
export type FetchCollectionsAllQueryHookResult = ReturnType<typeof useFetchCollectionsAllQuery>;
export type FetchCollectionsAllLazyQueryHookResult = ReturnType<typeof useFetchCollectionsAllLazyQuery>;
export type FetchCollectionsAllSuspenseQueryHookResult = ReturnType<typeof useFetchCollectionsAllSuspenseQuery>;
export type FetchCollectionsAllQueryResult = Apollo.QueryResult<Types.FetchCollectionsAllQuery, Types.FetchCollectionsAllQueryVariables>;
export const FetchCollectionsByIdsDocument = gql`
    query FetchCollectionsByIds($ids: [ID!]!) {
  nodes(ids: $ids) {
    ... on Collection {
      id
      title
    }
  }
}
    `;

/**
 * __useFetchCollectionsByIdsQuery__
 *
 * To run a query within a React component, call `useFetchCollectionsByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCollectionsByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCollectionsByIdsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useFetchCollectionsByIdsQuery(baseOptions: Apollo.QueryHookOptions<Types.FetchCollectionsByIdsQuery, Types.FetchCollectionsByIdsQueryVariables> & ({ variables: Types.FetchCollectionsByIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.FetchCollectionsByIdsQuery, Types.FetchCollectionsByIdsQueryVariables>(FetchCollectionsByIdsDocument, options);
      }
export function useFetchCollectionsByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.FetchCollectionsByIdsQuery, Types.FetchCollectionsByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.FetchCollectionsByIdsQuery, Types.FetchCollectionsByIdsQueryVariables>(FetchCollectionsByIdsDocument, options);
        }
// @ts-ignore
export function useFetchCollectionsByIdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.FetchCollectionsByIdsQuery, Types.FetchCollectionsByIdsQueryVariables>): Apollo.UseSuspenseQueryResult<Types.FetchCollectionsByIdsQuery, Types.FetchCollectionsByIdsQueryVariables>;
export function useFetchCollectionsByIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.FetchCollectionsByIdsQuery, Types.FetchCollectionsByIdsQueryVariables>): Apollo.UseSuspenseQueryResult<Types.FetchCollectionsByIdsQuery | undefined, Types.FetchCollectionsByIdsQueryVariables>;
export function useFetchCollectionsByIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.FetchCollectionsByIdsQuery, Types.FetchCollectionsByIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.FetchCollectionsByIdsQuery, Types.FetchCollectionsByIdsQueryVariables>(FetchCollectionsByIdsDocument, options);
        }
export type FetchCollectionsByIdsQueryHookResult = ReturnType<typeof useFetchCollectionsByIdsQuery>;
export type FetchCollectionsByIdsLazyQueryHookResult = ReturnType<typeof useFetchCollectionsByIdsLazyQuery>;
export type FetchCollectionsByIdsSuspenseQueryHookResult = ReturnType<typeof useFetchCollectionsByIdsSuspenseQuery>;
export type FetchCollectionsByIdsQueryResult = Apollo.QueryResult<Types.FetchCollectionsByIdsQuery, Types.FetchCollectionsByIdsQueryVariables>;